import React from "react";
import { NavLink } from "react-router-dom";
import Layout from "./Layout";

const ADMIN_LINKS = [
  { to: "/admin", label: "Inquiries", end: true },
  { to: "/admin/projects", label: "Projects" },
  { to: "/admin/press", label: "Press" },
  { to: "/admin/pitch-decks", label: "Pitch Decks" },
];

export default function AdminLayout({ children, title, overline = "— Admin Console" }) {
  return (
    <Layout>
      <section className="pt-32 pb-8 px-6 lg:px-12">
        <div className="max-w-[1600px] mx-auto">
          <div className="overline mb-3">{overline}</div>
          <h1 className="font-serif text-4xl md:text-6xl leading-[1.0] font-light tracking-tight">
            {title}
          </h1>
        </div>
      </section>
      <section className="px-6 lg:px-12 border-b border-primary/10">
        <div className="max-w-[1600px] mx-auto flex flex-wrap gap-1 -mb-px">
          {ADMIN_LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-testid={`admin-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `px-6 py-4 text-[12px] uppercase tracking-[0.22em] border-b-2 transition-colors ${
                  isActive
                    ? "border-primary text-primary"
                    : "border-transparent text-foreground/60 hover:text-foreground"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </div>
      </section>
      <section className="px-6 lg:px-12 py-12 pb-24">
        <div className="max-w-[1600px] mx-auto">{children}</div>
      </section>
    </Layout>
  );
}
